import React from 'react';
import {
  useDropzone,
  useFileInput,
} from '@uppy/react';

interface DropzoneProps {
  uploading: boolean;
  progress: number;
}

const Dropzone: React.FC<DropzoneProps> = ({ uploading, progress }) => {
  const { getRootProps, getInputProps } = useDropzone();
  const { getButtonProps } = useFileInput();

  return (
    <div className="timeline-create-files-dropzone">
      <input {...getInputProps()} className="wa-visually-hidden" disabled={uploading} />
      <div {...getRootProps()} className="dropzone-area">
        <span>
          <i className="fa-light fa-arrow-up-from-bracket fa-2x" />
        </span>
        <h4>Drop everything in here</h4>
        <p>
          Upload 10 to 500+ photos and videos at once.<br />
          We'll read the dates from your files and organise them into memories automatically.
        </p>
        <wa-button {...getButtonProps()} disabled={uploading}>
          {uploading ? (
            <>
              <wa-spinner slot="start" />
              {`Uploading (${progress}%)...`}
            </>
          ) : (
            <>
              <i className="fa-light fa-arrow-up-from-bracket" />{' '}
              Choose files
            </>
          )}
        </wa-button>
      </div>
    </div>
  );
}

export default Dropzone;
